export default "__VITE_ASSET__DDzjILcy__"